import { FC, useCallback, useEffect, useMemo } from "react";
import { Card, Container, Grid, Skeleton } from "@mui/material";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { HighlightedTitleText } from "components/Typography";
import { useIsMobile, usePcBundle } from "hooks";
import { useRouter } from "next/router";
import { FlexBox } from "components/flex-box";
import { PcBundleCard } from "components/product-cards/PcBundleCard";
import NothingToShow from "components/worth-it-builder/NothingToShow";

type Props = {};

const PoweredBuildPage: FC<Props> = ({}) => {
  const isMobile = useIsMobile();
  const { query } = useRouter();
  const {
    isLoading,
    bundleList,
    getPcBundleList,
    onHandleNavigateBundleDetails,
  } = usePcBundle();

  const brandNamePayload = useMemo(() => {
    return query?.id?.toString();
  }, [query?.id]);

  useEffect(() => {
    getPcBundleList(brandNamePayload);
  }, [brandNamePayload, getPcBundleList]);

  const poweredBuildSkeleton = () => {
    return (
      <Grid container spacing={1.5} sx={{ mt: 1 }}>
        {[...Array(3)].map((_, index) => (
          <Grid key={index} item xs={6} sm={6} md={4}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: 1,
              }}
            >
              <Skeleton
                variant="rectangular"
                width={isMobile ? 150 : 350}
                height={isMobile ? 150 : 300}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <ShopLayout1 title="Powered Builds" navbar={<Navbar />}>
      <Container
        maxWidth="lg"
        sx={{ p: "1rem", pt: "3rem", pb: { xs: "3rem", md: "10rem" } }}
      >
        {isLoading ? (
          poweredBuildSkeleton()
        ) : (
          <>
            <FlexBox sx={{ display: "grid", placeItems: "center", mb: 3 }}>
              <HighlightedTitleText
                text={"BUILDS"}
                highlightText={"POWERED"}
                variant="h4"
              />
            </FlexBox>
            <FlexBox>
              <Grid container spacing={1.5} sx={{ mt: 1 }}>
                {bundleList.map((pc_bundle, index) => (
                  <Grid key={index} item xs={12} sm={6} md={3}>
                    <PcBundleCard
                      pc_bundle_data={pc_bundle}
                      onHandleNavigateDetails={() =>
                        onHandleNavigateBundleDetails(
                          pc_bundle?.pc_bundle_id,
                          pc_bundle?.pc_bundle_slug
                        )
                      }
                    />
                  </Grid>
                ))}

                {!isLoading && bundleList?.length <= 0 && (
                  <NothingToShow
                    image={"/assets/images/kachi/kachi-nervous.png"}
                    title={"No results available. Try a different brand"}
                    subtitle={"NO PC BUNDLE FOUND"}
                    noBackground={true}
                  />
                )}
              </Grid>
            </FlexBox>
          </>
        )}
      </Container>
    </ShopLayout1>
  );
};

export default PoweredBuildPage;
